import { AiChatMessageMode } from '@server/ai';
import type { AgentsHomeState } from './agentsHomeReducer';
import { agentsHomeInitialState } from './agentsHomeReducer';

const VALID_MODES = new Set<string>(Object.values(AiChatMessageMode));

/**
 * Sanitizes a persisted advancedMode value that may be stale or unknown
 * (any string not in {@link AiChatMessageMode}).
 */
const normalizeAdvancedMode = (value: unknown): AiChatMessageMode =>
  typeof value === 'string' && VALID_MODES.has(value) && value !== AiChatMessageMode.None
    ? (value as AiChatMessageMode)
    : AiChatMessageMode.None;

/**
 * Returns the subset of AgentsHomeState to persist to localStorage,
 * with any stale values sanitized.
 */
export const agentsHomePersistedStateHandler = (state: AgentsHomeState) => ({
  ...agentsHomeInitialState,
  advancedMode: normalizeAdvancedMode(state.advancedMode),
});
